import { FC } from 'react';

import { Header, Page } from '@wearehelpful/ui-kit';
import { RoutePath } from '@common/constants';
import { Route, useRoute } from '@core/navigation';
import { useGetSurvey } from '@helpful/network';

import { Index } from './Index/Index';
import { Success } from './Success/Success';
import { Schedule } from './Schedule/Schedule';
import { MatchingContext } from './Matching.context';
import { MatchingSearch } from './Matching.types';

export const Matching: FC = () => {
  const [{ search, pathname }] = useRoute<{}, MatchingSearch>();

  const { isLoading, isSuccess, data } = useGetSurvey(search?.id);

  const headerBackground = (() => {
    if (pathname.includes('/success')) {
      return 'white100';
    }
    return 'periwinkle300';
  })();

  return (
    <Page headerBackground={headerBackground}>
      <Header>
        <Header.Back defaultHref={RoutePath.ROOT} />
      </Header>
      <MatchingContext.Provider
        value={{ isLoading, isSuccess, survey: data?.data }}
      >
        <Route path={RoutePath.THERAPISTS_MATCHING} exact>
          <Index />
        </Route>
        <Route path={RoutePath.THERAPISTS_MATCHING_SCHEDULE}>
          <Schedule />
        </Route>
        <Route path={RoutePath.THERAPISTS_MATCHING_SUCCESS}>
          <Success />
        </Route>
      </MatchingContext.Provider>
    </Page>
  );
};
